// extracted by mini-css-extract-plugin
export default {"handling":"handling-form_handling__1Zsbd","row":"handling-form_row__xOVv+","containerField":"handling-form_containerField__wz5dQ","checkbox":"handling-form_checkbox__wrHVD"};